import React from "react";
import VFFPageTab from "../Tabs/VFFPage";

const VFFPage = ({ user }) => {
	return <VFFPageTab user={user} />;
};

export default VFFPage;
